export default __webpack_public_path__ + "static/karnov-6070c7f96e54a675e3c6bb25d180b401.png";